//  Copyright (c) 2013 David Caldwell,  All Rights Reserved.

var on_load = require('./dom').on_load;
var timeout = require('./dom').timeout;
var doc = require('./dom').doc
var Alert = require('./alert');

on_load(function() {
    timeout(2000, function() { // it gets injected later
        if (window.iminent && !localStorage.dont_warn_iminent) {
            var alert = new Alert(doc(["div",
                                       ["p", 'We have detected the "Iminent" extension running in your browser.'],
                                       ['p', 'This extension is malware and has been known to cause problems with Green Felt.'],
                                       ['p', 'We recommend ',
                                        ['a', { href: 'http://malwaretips.com/blogs/remove-iminent-toolbar/' }, 'uninstalling it'], '.'],
                                       ['button', { onclick: function() { localStorage.dont_warn_iminent = true; alert.close(); } }, "Don't warn me again"]]),
                                  { goaway: true, title: '"Iminent" Detected' });
        }
    });
})
//  Copyright (c) 2013 David Caldwell,  All Rights Reserved.

var on_load = require('./dom').on_load;
var timeout = require('./dom').timeout;
var doc = require('./dom').doc
var Alert = require('./alert');

on_load(function() {
    timeout(2000, function() { // it gets injected later
        if (window.iminent && !localStorage.dont_warn_iminent) {
            var alert = new Alert(doc(["div",
                                       ["p", 'We have detected the "Iminent" extension running in your browser.'],
                                       ['p', 'This extension is malware and has been known to cause problems with Green Felt.'],
                                       ['p', 'We recommend ',
                                        ['a', { href: 'http://malwaretips.com/blogs/remove-iminent-toolbar/' }, 'uninstalling it'], '.'],
                                       ['button', { onclick: function() { localStorage.dont_warn_iminent = true; alert.close(); } }, "Don't warn me again"]]),
                                  { goaway: true, title: '"Iminent" Detected' });
        }
    });
})
